export const dynamicLinkFallbackConstants = {
  subHeading: `# Browser Not Supported`,
  text: `#### Digital Mastercard links will not work on your web browser, please reopen this link on your smartphone.`,
}